import { twMerge } from 'tailwind-merge';
import { Icon } from '@acme/assets';
import { TextInput } from 'flowbite-react';
import { DatePickerRange, FilterDropdown } from '@acme/foundation';
import { OperationsFiltersValue } from '../../config';

type OperationsFiltersProps = {
  value: OperationsFiltersValue;
  onChange: (value: OperationsFiltersValue) => void;
  className?: string;
};

const typeOperationsOptions = [
  { value: 'all', label: 'Все' },
  { value: 'deposit', label: 'Пополнение' },
  { value: 'withdraw', label: 'Списание' },
];

export const OperationsFilters = (props: OperationsFiltersProps) => {
  return (
    <div className={twMerge('flex gap-4 items-center', props.className)}>
      <FilterDropdown<string>
        title="Тип операции"
        value={props.value.type}
        options={typeOperationsOptions}
        onChange={(value) => props.onChange({ ...props.value, type: value })}
      />
      <DatePickerRange
        value={props.value.period}
        onChange={(period) => {
          props.onChange({ ...props.value, period: period });
        }}
      />

      <TextInput
        className="ml-auto"
        icon={() => <Icon name="search-outline" />}
        onChange={(event) =>
          props.onChange({ ...props.value, search: event.target.value })
        }
        placeholder="Номер заявки"
      />
    </div>
  );
};
